"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const SvgAmenityAttendant = (props, ref) => (React.createElement("svg", { ...props, xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", viewBox: "0 0 1024 1024", fill: "currentColor", className: `Icon ${props?.className || ""}`, ref: ref },
    React.createElement("path", { d: "M512 352c96 0 176-80 176-176S608 0 512 0 336 80 336 176s80 176 176 176m0-288c60.8 0 112 51.2 112 112s-51.2 112-112 112-112-51.2-112-112S451.2 64 512 64m0 320c-195.2 0-352 156.8-352 352 0 19.2 12.8 32 32 32h128v224c0 19.2 12.8 32 32 32h320c19.2 0 32-12.8 32-32V768h128c19.2 0 32-12.8 32-32 0-195.2-156.8-352-352-352m160 320c-19.2 0-32 12.8-32 32v224H384V736c0-19.2-12.8-32-32-32H227.2c16-144 137.6-256 284.8-256s268.8 112 284.8 256z" })));
const ForwardRef = (0, react_1.forwardRef)(SvgAmenityAttendant);
exports.default = ForwardRef;
